const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M234.8,170.5h0c0,0,.1,0,.2,0h0s0,0,.1,0h0s0,0,.1,0h0c0,0,.2,0,.3,0h0c.2,0,.4.1.5.2h0c0,0,.2,0,.3.1h0c.5.2,1,.5,1.4.7h0s0,0,0,0h0c1.2.8,2.2,1.9,3,3.1.7,1.2,1.2,2.5,1.4,3.9,0,.5,0,1,0,1.4v51.9c0,5.4-4.4,9.8-9.8,9.8s-9.7-4.3-9.8-9.6v-.2s0-20.1,0-20.1c-23.4,26.8-57.3,42.8-94.4,42.8s-92.5-27.7-113.8-70.5c-2.4-4.8-.4-10.7,4.4-13.1,4.8-2.4,10.7-.4,13.1,4.4,18,36.3,55.1,59.7,96.3,59.7s67.3-17.3,87-45.6h-27c-5.4,0-9.8-4.4-9.8-9.8s4.3-9.7,9.6-9.8h.2s44,0,44,0c.8,0,1.5,0,2.3.2Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,84.7c8.8-8.8,23-8.9,31.9-.3l.3.3,27.6,27.6c8.9,8.9,8.9,23.3,0,32.2h0s0,.1,0,.1h0s0,0,0,0h0c0,0,0,.1,0,.1l-27.3,27.3c-8.8,8.8-23,8.9-31.9.3l-.3-.3-27.6-27.6c-8.9-8.9-8.9-23.3,0-32.2h0c0,0,0-.1,0-.1h0s0,0,0,0h0c0,0,27.3-27.4,27.3-27.4Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,1.1c48.7,0,92.5,27.7,113.8,70.5,2.4,4.8.4,10.7-4.4,13.1-4.8,2.4-10.7.4-13.1-4.4-18-36.3-55.1-59.7-96.3-59.7s-67.3,17.3-87,45.6h27c5.4,0,9.8,4.4,9.8,9.8s-4.3,9.7-9.6,9.8h-.2s-44,0-44,0c-.8,0-1.6,0-2.3-.2h0s0,0,0,0c0,0,0,0-.1,0h0s0,0,0,0h0s0,0,0,0h0c-.1,0-.3,0-.4-.1h0c-.3-.1-.6-.2-.8-.3h0c-.6-.3-1.1-.6-1.6-.9h0c-1.1-.8-2.1-1.8-2.8-3-.7-1.2-1.2-2.5-1.4-3.9,0-.5,0-1,0-1.4V23.9c0-5.4,4.4-9.8,9.8-9.8s9.7,4.3,9.8,9.6v.2s0,20.1,0,20.1C56.7,17.2,90.6,1.1,127.7,1.1h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3350fa3eeffc72ab4cedebd81290341e.svg";
export { ForwardRef as ReactComponent };